/** @format */

import { BtnPrimary, CancelBtn } from "../global/btns/btns";
import InputField from "../inputs/inputField";
import InputPassword from "../inputs/inputPassword";

export const ManagerInfo = ({ managerProfile }) => {
  return (
    <div className='personal__container'>
      <from className='personal__form'>
        <div className='personal__form-side'>
          <InputField title='الاسم ' note='*' value={managerProfile.name} />

          <div className='mb__small' />
          <InputField
            title='رقم الموبايل '
            note='(اختياري)'
            value={managerProfile.phone_number}
          />
        </div>
        <div className='personal__form-side'>
          <InputField
            title=' البريد الالكتروني  '
            note='*'
            value={managerProfile.email}
          />
        </div>
      </from>
      <div
        className='flex-between'
        style={{ width: "80%", flexDirection: "row" }}>
        <BtnPrimary action='تعديل' />
        <CancelBtn />
      </div>
    </div>
  );
};
